import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { CkEditorComponent } from "../ck-editor/ck-editor.component";
import { DaveDoubleIconModule } from "../dave-double-icon/dave-double-icon.module";
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { SmallFileCardModule } from "../small-file-card/small-file-card.module";
import { CommentCardComponent } from "./components/comment-card/comment-card.component";
import { CommentInlineEditorComponent } from "./components/comment-inline-editor/comment-inline-editor.component";
import { CommentListComponent } from './components/comment-list/comment-list.component';
import { CommentListDialogComponent } from './components/comment-list-dialog/comment-list-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';



@NgModule({
    declarations: [CommentListComponent, CommentListDialogComponent],
    exports: [CommentListComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatExpansionModule,
        FontAwesomeModule,
        AppButtonModule,
        // CKEditorModule,
        FormsModule,
        MatTooltipModule,
        SmallFileCardModule,
        DaveDoubleIconModule,
        MatButtonModule,
        DropzoneModule,
        CkEditorComponent,
        CommentCardComponent,
        CommentInlineEditorComponent,
        MatDialogModule,
    ],
})
export class DaveCommentsModule {}
